import React from 'react'

function Loading() {
  return (
    <div className="com-loading">
      <div className="square-spin"></div>
    </div>
  )
}

export default Loading
